import Vue from 'vue'
import user from '@/store/app/user/user'
import passwordGuard from '@/store/app/passwordGuard'
import helper from '@/store/app/helper'
import tickets from '@/store/app/tickets'
import currencies from '@/store/common/currencies'
import countries from '@/store/common/countries'
import invitations from '@/store/app/invitations'
import constants from '@/store/app/constants'
import router from "@/router";

export default {
    namespaced: true,
    modules: {
        user,
        passwordGuard,
        helper,
        tickets,
        constants,
        currencies,
        countries,
        invitations,
    },
    actions: {
        async fetchUserAndSpaces({dispatch, rootState}) {
            const userId = rootState.auth.user.sub;
            return Promise.all([
                dispatch('currencies/getCurrencies'),
                dispatch('user/getUserInfo', userId),
                dispatch('space/getActiveSpaces', {}, {root: true}),
            ])
        },
        async initCabinet({commit, dispatch, getters, state, rootState}) {
            try {
                //check if user has email invite token
                let emailInviteToken = localStorage.getItem('email_invite');
                if (!!emailInviteToken) {
                    await dispatch('invitations/connectInviteWithToken', emailInviteToken);
                    localStorage.removeItem('email_invite');
                }

                await dispatch('fetchUserAndSpaces')
                const userCurrentSpaceId = state.user.user_info.data.space_id;
                if (!userCurrentSpaceId && rootState.space.spaces.length) {
                    dispatch('user/setUserPrimarySpaceId', rootState.space.spaces[0].id)
                }

                //storing user invitations in invitations module
                let userInvites = [...state.user.user_info.data.invitations];
                userInvites = userInvites.filter(invite => invite.status === 0);
                dispatch('invitations/setUserInvites', userInvites)


                //if user has no space in cabinet => navigate properly and reset space dirty state
                if (!userCurrentSpaceId && !rootState.space.spaces.length) {
                    // no invites -> go to create accounting
                    // if invites -> go to office intro with invites
                    if (!userInvites.length) {
                        await router.push({name: 'create-accounting'}).catch(e => {
                        })
                    } else {
                        await router.push({name: 'home', params: {...router.params}}).catch(e => {
                        })
                    }
                    commit('space/clearCurrentSpaceInfoDirty', {}, {root: true})
                }
                //apply users theme settings
                let userSettings = state.user.user_info.data.settings;
                commit('theme/setColorTheme', userSettings.theme || 1, {root: true})
                commit('theme/setFontTheme', userSettings.font_size || 3, {root: true})
            } catch (err) {
                console.error(err)
            }
        },
        forwardUserFromDeletedSpace({state, dispatch, rootGetters}) {
            let spacesList = rootGetters['space/spacesList'];
            // if user has spaces navigate pick another space else navigate to intro/create-accounting
            if (spacesList.length === 0) {
                dispatch('user/setUserPrimarySpaceId', null);

                //if no invites go to create accounting
                state.invitations.invitations.length
                    ? router.push({name: 'home'})
                    : router.push({name: 'create-accounting'})
            } else {
                dispatch('user/setUserPrimarySpaceId', spacesList[0].id);
                Vue.prototype.$toasted.info(`Переходим в ${spacesList[0].title}`);
            }
        }
    }
}